var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"synergy-friends"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"m-btn",on:{"click":function($event){return _vm.openModal(_vm.MODAL_TYPES.synergyFriends)}}},[_vm._v("\n    узнать больше\n  ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',[_vm._v("учись в школе и получи айфон "),_c('span',[_vm._v("бесплатно")])])
}]

export { render, staticRenderFns }